/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import {
  Button,
  Combobox,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import {
  useGetCashCenters,
  useGetOffices,
  useGetRegions,
} from "utils/apis/lookups.api";
// eslint-disable-next-line import/no-cycle
import { showToast } from "utils/helper";
import { useAddNewRoute } from "utils/apis/rotes.api";

const jobPriorities = [
  {
    value: "1",
    label: "High",
  },
  {
    value: "2",
    label: "Normal",
  },
  {
    value: "3",
    label: "Low",
  },
];

const currentDate = new Date();

function AddRoute({ onAddRoute }: { onAddRoute: () => void }) {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnSaveText, setBtnSaveText] = useState("Save");

  const [route, setRoute] = useState({
    cashCenter: "",
    office: "",
    routeNo: "",
    description: "",
    routeArea: "",
    priority: "",
    requiredTeamMembers: 0,
    teamNationalityCount: 0,
    routeStartTime: currentDate,
    routeEndTime: currentDate,
  });

  const [error, setError] = useState<any>({
    cashCenter: "",
    office: "",
    routeNo: "",
    description: "",
    routeArea: "",
    priority: "",
    requiredTeamMembers: 0,
    teamNationalityCount: 0,
    routeStartTime: null,
    routeEndTime: null,
  });

  const { data: cashCenters } = useGetCashCenters();
  const { data: cities } = useGetRegions("UAE");
  const { mutate: getOffices, data: offices } = useGetOffices();
  const {
    mutate: addNewRoute,
    isSuccess: addNewRouteSuccess,
    isError: addNewRouteError,
  } = useAddNewRoute();
  const onCashCentersChanged = (value: string) => {
    setRoute({ ...route, cashCenter: value });
    if (!value) return;
    getOffices(value);
  };

  const onBtnAddRouteClicked = () => {
    let errorCount = 0;

    const errorObj: any = {
      cashCenter: "",
      routeNo: "",
      description: "",
      routeArea: "",
      priority: "",
      requiredTeamMembers: 0,
      teamNationalityCount: 0,
      routeStartTime: null,
      routeEndTime: null,
    };

    if (!route.cashCenter || !route.cashCenter) {
      errorCount++;
      errorObj.cashCenter = "indianred";
    }

    if (route.description === "") {
      errorCount++;
      errorObj.description = "indianred";
    }

    if (route.routeNo === "") {
      errorCount++;
      errorObj.routeNo = "indianred";
    }

    if (!route.routeArea || !route.routeArea) {
      errorCount++;
      errorObj.routeArea = "indianred";
    }

    if (route.requiredTeamMembers === 0) {
      errorCount++;
      errorObj.requiredTeamMembers = "indianred";
    }

    if (route.teamNationalityCount === 0) {
      errorCount++;
      errorObj.teamNationalityCount = "indianred";
    }

    if (route.routeStartTime === null) {
      errorCount++;
      errorObj.routeStartTime = "indianred";
    }

    if (route.routeEndTime === null) {
      errorCount++;
      errorObj.routeEndTime = "indianred";
    }

    if (errorCount) {
      showToast("error", "Fields are required");
      setError(errorObj);
      return;
    }
    setError(errorObj);

    const obj = {
      cashCenterId: route.cashCenter,
      officeId: route.office,
      routeNo: route.routeNo,
      description: route.description,
      routeArea: route.routeArea,
      priority: route.priority,
      requiredTeamMembers: route.requiredTeamMembers,
      teamNationalityCount: route.teamNationalityCount,
      routeStartTime: route.routeStartTime,
      routeEndTime: route.routeEndTime,
    };

    setBtnDisabled(true);
    setBtnSaveText("Adding Route....");
    addNewRoute(obj);
  };

  useEffect(() => {
    if (addNewRouteSuccess) {
      setBtnDisabled(false);
      setBtnSaveText("Save");
      setRoute({
        cashCenter: "",
        office: "",
        routeNo: "",
        description: "",
        routeArea: "",
        priority: "",
        requiredTeamMembers: 0,
        teamNationalityCount: 0,
        routeStartTime: currentDate,
        routeEndTime: currentDate,
      });
      onAddRoute();
    }
    if (addNewRouteError) {
      setBtnDisabled(false);
      setBtnSaveText("Save");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addNewRouteSuccess, addNewRouteError]);
  return (
    <>
      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.cashCenter}]`}>
            Cash Center<sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={cashCenters?.map((m) => ({
              value: m.cashCenterId,
              label: m.name,
            }))}
            value={route.cashCenter}
            setValue={onCashCentersChanged}
            placeholder="Select Cash center"
          />
        </div>

        <div className="flex-1">
          <label>Office</label>
          <Combobox
            data={offices?.map((m: any) => ({
              value: m.officeId,
              label: m.officeName,
            }))}
            placeholder="Select Office"
            value={route.office}
            setValue={(e: string) => {
              setRoute({ ...route, office: e });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-{${error.routeNo}}`}>
            Route No
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route No"
            value={route.routeNo}
            onChange={(e) => {
              setRoute({ ...route, routeNo: e.target.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.description}}`}>
            Description
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route Description"
            value={route.description}
            onChange={(e) => {
              setRoute({ ...route, description: e.target.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.routeArea}}`}>
            Route Area
            <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={cities?.map((m: any) => ({
              label: m.name,
              value: m.name,
            }))}
            value={route.routeArea}
            setValue={(e: string) => {
              setRoute({ ...route, routeArea: e });
            }}
            placeholder="Select Route Area"
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-{${error.priority}}`}>
            Priority
            <sup className="text-red-500">*</sup>
          </label>
          <Select
            onValueChange={(e) => {
              setRoute({ ...route, priority: e });
            }}
            value={route.priority}
          >
            <SelectTrigger>
              <SelectValue placeholder="Route Priority" />
            </SelectTrigger>
            <SelectContent>
              {jobPriorities?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex-1">
          <label className={`text-{${error.requiredTeamMembers}}`}>
            Required Team Members Count
            <sup className="text-red-500">*</sup>
          </label>
          <NumericTextBox
            min={3}
            className="h-10"
            placeholder="Required Team Members Count"
            value={route.requiredTeamMembers}
            onChange={(e) => {
              setRoute({
                ...route,
                requiredTeamMembers: e.target.value as number,
              });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.teamNationalityCount}}`}>
            Required Nationalities
            <sup className="text-red-500">*</sup>
          </label>
          <NumericTextBox
            min={1}
            className="h-10"
            placeholder="Max. Same Nationals Count"
            value={route.teamNationalityCount}
            onChange={(e) => {
              setRoute({
                ...route,
                teamNationalityCount: e.target.value as number,
              });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4">
        <div className="flex-1">
          <label className={`text-{${error.routeStartTime}}`}>
            Route Start Time
            <sup className="text-red-500">*</sup>
          </label>
          <TimePicker
            placeholder="Route Start Time"
            className="h-10"
            value={route.routeStartTime}
            onChange={(e) => {
              setRoute({ ...route, routeStartTime: e.value as Date });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-{${error.routeEndTime}}`}>
            Route End Time
            <sup className="text-red-500">*</sup>
          </label>
          <TimePicker
            className="h-10"
            placeholder="Route Start Time"
            value={route.routeEndTime}
            onChange={(e) => {
              setRoute({ ...route, routeEndTime: e.value as Date });
            }}
          />
        </div>
      </div>
      <div className="border-b my-3 bg-accent" />
      <Button
        variant="secondary"
        onClick={onBtnAddRouteClicked}
        disabled={btnDisabled}
        className="ml-auto flex w-[140px]"
      >
        {btnSaveText}
      </Button>
    </>
  );
}

export default AddRoute;
